import PropTypes from 'prop-types';

const propTypes = {
  key: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

class ConversionPoint {
  static propTypes = propTypes;
}

export default ConversionPoint;
